import Vue from 'vue';

const success = (response, context) => {
  toastr.success(context.$t('account.settings.user_data_section.stripe_account_update_success'));
  context.closeModal('#addStripeAccount');
  context.smallLoading = false;
  context.$emit('getStripeAccounts');
};

const failed = (error, context) => {
  context.smallLoading = false;
  if (error.response.data.msg === 'requires_action') {
    context.connectStripe();
  } else {
    context.showToasterError(error);
  }
};

export default (context, stripeAccount) => {
  return Vue.$http.post('/update-stripe-account', stripeAccount)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/stripe_accounts/update.js